<template>
  <div class="galeria-page">
    <div class="container">
      <!-- Thumbnail Grid -->
      <div class="galeria-grid">
        <div
          v-for="(imagen, index) in imagenes"
          :key="index"
          class="galeria-thumb"
          @click="openLightbox(index)"
        >
          <img :src="`/images/galeria/${imagen}`" :alt="`Foto ${index + 1}`">
          <div class="thumb-overlay">
            <span class="zoom-icon">🔍</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Lightbox Modal -->
    <div v-if="lightboxOpen" class="lightbox" @click.self="closeLightbox">
      <button class="lightbox-close" @click="closeLightbox">&times;</button>
      <button class="lightbox-prev" @click="prevImage">&#10094;</button>
      <button class="lightbox-next" @click="nextImage">&#10095;</button>

      <div class="lightbox-content">
        <img :src="`/images/galeria/${imagenes[currentIndex]}`" :alt="`Foto ${currentIndex + 1}`">
        <div class="lightbox-counter">{{ currentIndex + 1 }} / {{ imagenes.length }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GaleriaPage',
  data() {
    return {
      // List your image filenames here
      imagenes: [
        'foto1.jpeg',
        'foto2.jpeg',
        'foto3.jpeg',
        'foto4.jpeg',
        'foto5.jpeg',
        'foto6.jpeg',
        'foto7.jpeg',
        'foto8.jpeg',
        'foto9.jpeg',
        'foto10.jpeg',
      ],
      lightboxOpen: false,
      currentIndex: 0
    }
  },
  methods: {
    openLightbox(index) {
      this.currentIndex = index;
      this.lightboxOpen = true;
      document.body.style.overflow = 'hidden';
    },
    closeLightbox() {
      this.lightboxOpen = false;
      document.body.style.overflow = '';
    },
    nextImage() {
      this.currentIndex = (this.currentIndex + 1) % this.imagenes.length;
    },
    prevImage() {
      this.currentIndex = (this.currentIndex - 1 + this.imagenes.length) % this.imagenes.length;
    },
    handleKeydown(e) {
      if (!this.lightboxOpen) return;
      if (e.key === 'Escape') this.closeLightbox();
      if (e.key === 'ArrowRight') this.nextImage();
      if (e.key === 'ArrowLeft') this.prevImage();
    }
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeydown);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeydown);
  }
}
</script>

<style scoped>
.galeria-page {
  background: #000;
  padding: 60px 0 80px;
  min-height: 50vh;
}

/* Thumbnail Grid */
.galeria-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

.galeria-thumb {
  position: relative;
  aspect-ratio: 1 / 1;
  overflow: hidden;
  border-radius: 10px;
  cursor: pointer;
  background: #111;
}

.galeria-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease;
}

.galeria-thumb:hover img {
  transform: scale(1.1);
}

.thumb-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.galeria-thumb:hover .thumb-overlay {
  opacity: 1;
}

.zoom-icon {
  font-size: 40px;
}

/* Lightbox */
.lightbox {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.95);
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.lightbox-content {
  max-width: 90vw;
  max-height: 90vh;
  position: relative;
}

.lightbox-content img {
  max-width: 90vw;
  max-height: 85vh;
  object-fit: contain;
  border-radius: 8px;
}

.lightbox-close {
  position: absolute;
  top: 20px;
  right: 30px;
  font-size: 50px;
  color: white;
  background: none;
  border: none;
  cursor: pointer;
  z-index: 100001;
  transition: color 0.3s ease;
}

.lightbox-close:hover {
  color: #c9a227;
}

.lightbox-prev,
.lightbox-next {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-size: 50px;
  color: white;
  background: rgba(0, 0, 0, 0.5);
  border: none;
  cursor: pointer;
  padding: 20px 15px;
  transition: all 0.3s ease;
  z-index: 100001;
}

.lightbox-prev {
  left: 20px;
  border-radius: 0 8px 8px 0;
}

.lightbox-next {
  right: 20px;
  border-radius: 8px 0 0 8px;
}

.lightbox-prev:hover,
.lightbox-next:hover {
  background: rgba(201, 162, 39, 0.8);
}

.lightbox-counter {
  text-align: center;
  color: #aaa;
  margin-top: 15px;
  font-size: 14px;
}

/* Mobile */
@media (max-width: 767px) {
  .galeria-page {
    padding: 40px 15px 60px;
  }

  .galeria-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }

  .lightbox-prev,
  .lightbox-next {
    font-size: 30px;
    padding: 15px 10px;
  }

  .lightbox-prev {
    left: 10px;
  }

  .lightbox-next {
    right: 10px;
  }

  .lightbox-close {
    top: 10px;
    right: 15px;
    font-size: 40px;
  }
}
</style>